import React, { useEffect } from "react";
import funnel from "../../styles/Funnel.module.css";
import Box from "@mui/material/Box";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";

function Schools({ formData, setFormData }) {
  const handleChangeType = (e) => {
    const { value, checked } = e.target;
    const { Type_of_schools } = formData;

    if (checked) {
      setFormData({
        ...formData,
        Type_of_schools: [...Type_of_schools, value],
      });
    } else {
      setFormData({
        ...formData,
        Type_of_schools: Type_of_schools.filter((e) => e !== value),
      });
    }
  };

  const handleChangeGender = (e) => {
    const { value, checked } = e.target;
    const { Gender } = formData;

    if (checked) {
      setFormData({
        ...formData,
        Gender: [...Gender, value],
      });
    } else {
      setFormData({
        ...formData,
        Gender: Gender.filter((e) => e !== value),
      });
    }
  };

  const handleChangeLevel = (e) => {
    const { value, checked } = e.target;
    const { Level } = formData;

    if (checked) {
      setFormData({
        ...formData,
        Level: [...Level, value],
      });
    } else {
      setFormData({
        ...formData,
        Level: Level.filter((e) => e !== value),
      });
    }
  };

  let Private = (
    <FormControlLabel
      control={
        <Checkbox
          name="Type of schools"
          value="Private"
          onChange={handleChangeType}
          sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
        />
      }
      label="Private"
    />
  );

  let Catholic = (
    <FormControlLabel
      control={
        <Checkbox
          name="Type of schools"
          value="Catholic"
          onChange={handleChangeType}
          sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
        />
      }
      label="Catholic"
    />
  );

  let Government = (
    <FormControlLabel
      control={
        <Checkbox
          name="Type of schools"
          value="Government"
          onChange={handleChangeType}
          sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
        />
      }
      label="Government"
    />
  );

  let Boys = (
    <FormControlLabel
      control={
        <Checkbox
          name="Gender"
          value="Boys"
          onChange={handleChangeGender}
          sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
        />
      }
      label="Boys"
    />
  );

  let Girls = (
    <FormControlLabel
      control={
        <Checkbox
          name="Gender"
          value="Girls"
          onChange={handleChangeGender}
          sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
        />
      }
      label="Girls"
    />
  );

  let CoEd = (
    <FormControlLabel
      control={
        <Checkbox
          name="Gender"
          value="CoEd"
          onChange={handleChangeGender}
          sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
        />
      }
      label="CoEd"
    />
  );

  let Primary = (
    <FormControlLabel
      control={
        <Checkbox
          name="Level"
          value="Primary"
          onChange={handleChangeLevel}
          sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
        />
      }
      label="Primary"
    />
  );

  let Secondary = (
    <FormControlLabel
      control={
        <Checkbox
          name="Level"
          value="Secondary"
          onChange={handleChangeLevel}
          sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
        />
      }
      label="Secondary"
    />
  );

  let Special = (
    <FormControlLabel
      control={
        <Checkbox
          name="Level"
          value="Special"
          onChange={handleChangeLevel}
          sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
        />
      }
      label="Special"
    />
  );
  for (const itemT in formData.Type_of_schools) {
    if (formData.Type_of_schools[itemT] == "Private") {
      Private = (
        <FormControlLabel
          control={
            <Checkbox
              name="Type of schools"
              value="Private"
              onChange={handleChangeType}
              sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
              checked
            />
          }
          label="Private"
        />
      );
    } else if (formData.Type_of_schools[itemT] == "Catholic") {
      Catholic = (
        <FormControlLabel
          control={
            <Checkbox
              name="Type of schools"
              value="Catholic"
              onChange={handleChangeType}
              sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
              checked
            />
          }
          label="Catholic"
        />
      );
    } else if (formData.Type_of_schools[itemT] == "Government") {
      Government = (
        <FormControlLabel
          control={
            <Checkbox
              name="Type of schools"
              value="Government"
              onChange={handleChangeType}
              sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
              checked
            />
          }
          label="Government"
        />
      );
    }
  }
  for (const itemG in formData.Gender) {
    if (formData.Gender[itemG] == "Boys") {
      Boys = (
        <FormControlLabel
          control={
            <Checkbox
              name="Gender"
              value="Boys"
              onChange={handleChangeGender}
              sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
              checked
            />
          }
          label="Boys"
        />
      );
    } else if (formData.Gender[itemG] == "Girls") {
      Girls = (
        <FormControlLabel
          control={
            <Checkbox
              name="Gender"
              value="Girls"
              onChange={handleChangeGender}
              sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
              checked
            />
          }
          label="Girls"
        />
      );
    } else if (formData.Gender[itemG] == "CoEd") {
      CoEd = (
        <FormControlLabel
          control={
            <Checkbox
              name="Gender"
              value="CoEd"
              onChange={handleChangeGender}
              sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
              checked
            />
          }
          label="CoEd"
        />
      );
    }
  }
  for (const itemL in formData.Level) {
    if (formData.Level[itemL] == "Primary") {
      Primary = (
        <FormControlLabel
          control={
            <Checkbox
              name="Level"
              value="Primary"
              onChange={handleChangeLevel}
              sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
              checked
            />
          }
          label="Primary"
        />
      );
    } else if (formData.Level[itemL] == "Secondary") {
      Secondary = (
        <FormControlLabel
          control={
            <Checkbox
              name="Level"
              value="Secondary"
              onChange={handleChangeLevel}
              sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
              checked
            />
          }
          label="Secondary"
        />
      );
    } else if (formData.Level[itemL] == "Special") {
      Special = (
        <FormControlLabel
          control={
            <Checkbox
              name="Level"
              value="Special"
              onChange={handleChangeLevel}
              sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
              checked
            />
          }
          label="Special"
        />
      );
    }
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <div className={funnel.boxQn}>
        <h2 className={funnel.h2Text}>What kinds of schools do you need?</h2>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <FormControl
            sx={{ m: 0, ml: 3, mr: 3 }}
            component="fieldset"
            variant="standard"
          >
            <FormLabel component="legend">Type of schools</FormLabel>
            <FormGroup>
              {Private}
              {Catholic}
              {Government}
            </FormGroup>
          </FormControl>
          <FormControl
            sx={(theme) => ({
              m: 0,
              ml: 3,
              mr: 3,
              [theme.breakpoints.down("sm")]: { mt: 3 },
            })}
            component="fieldset"
            variant="standard"
          >
            <FormLabel component="legend">Gender</FormLabel>
            <FormGroup>
              {Boys}
              {Girls}
              {CoEd}
            </FormGroup>
          </FormControl>
          <FormControl
            sx={(theme) => ({
              m: 0,
              ml: 3,
              mr: 3,
              [theme.breakpoints.down("sm")]: { mt: 3 },
            })}
            component="fieldset"
            variant="standard"
          >
            <FormLabel component="legend">Level</FormLabel>
            <FormGroup>
              {Primary}
              {Secondary}
              {Special}
            </FormGroup>
          </FormControl>
        </Box>
      </div>
    </Box>
  );
}

export default Schools;
